import { render, staticRenderFns } from "./TrailBalancePage.vue?vue&type=template&id=97a05e12&scoped=true"
import script from "./TrailBalancePage.vue?vue&type=script&lang=js"
export * from "./TrailBalancePage.vue?vue&type=script&lang=js"
import style0 from "./TrailBalancePage.vue?vue&type=style&index=0&id=97a05e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a05e12",
  null
  
)

export default component.exports